export type BlockKind =
  | "paragraph"
  | "heading1"
  | "heading2"
  | "heading3"
  | "list"
  | "ordered"
  | "task"
  | "quote"
  | "code";

export function safeLink(value: string): string | null {
  const url = value.trim();
  // App-relative links are safe; never accept protocol-relative hosts or backslashes.
  if (/^\/(?!\/)[^\s<>\\]*$/.test(url)) return url;
  if (!/^(https?:\/\/|mailto:)/i.test(url) || /[\s<>]/.test(url)) return null;
  try {
    return new URL(url).href;
  } catch {
    return null;
  }
}

/** A Markdown link, with its label escaped and its destination safe to write unbracketed. */
export function markdownLink(title: string, url: string): string {
  const label = title.replace(/[\\[\]]/g, "\\$&");
  const destination = url.replace(/\(/g, "%28").replace(/\)/g, "%29");
  return `[${label}](${destination})`;
}
